// extracted by mini-css-extract-plugin
module.exports = {"marginBottomXL":"FormMessage-FormMessage-marginBottomXL-6a2a9d00","marginBottomXl":"FormMessage-FormMessage-marginBottomXL-6a2a9d00"};